
    var riot = require('riot')
    //src: starling/src/tags/modal-image.html
riot.tag2('modal-image',
  '<div class="modal-background" onclick="{dismiss}" style="display: none;"></div> <div id="image-modal" class="modal fade" tabindex="-1" role="dialog" style="display: none;"> <div class="modal-dialog" role="document"> <div if="{this.edit && this.isImage()}" class="modal-content"> <div class="modal-header"> <h2 class="modal-title">{this.titleText()}</h2> <button class="modal-close" onclick="{dismiss}"> <i class="modal-close_icon material-icons">close</i> </button> </div> <div ref="previewContainer" class="preview-container"> <div class="spinner" ref="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> <img ref="previewImage" class="image-preview" riot-src="{this.previewSrc()}"> </div> <div class="button-container"> <button if="{showRotateButton()}" ref="rotateButton" class="Button Button--Outlined Button--XLarge" data-tip="Rotate" data-tip-align="top" onclick="{rotateImage}"> <svg class="Button__Icon"> <use xlink:href="#rotate-90-degrees-icon"></use> </svg> </button> <button ref="removeButton" class="Button Button--Outlined Button--XLarge" data-tip="Remove" data-tip-align="top" onclick="{removeFile}"> <svg class="Button__Icon"> <use xlink:href="#delete-icon"></use> </svg> </button> <button ref="saveButton" class="Button Button--Primary Button--XLarge" onclick="{uploadFile}"> Save </button> </div> </div> <div if="{this.edit && !this.isImage()}" class="modal-content"> <div class="file-preview"> <div class="spinner" ref="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> <h2 class="file-name">{this.getFileName()}</h2> <svg> <use xlink:href="#{this.getIconName()}"></use> </svg> </div> <div class="button-container"> <button ref="removeButton" class="Button Button--Outlined Button--XLarge" data-tip="Remove" data-tip-align="top" onclick="{removeFile}"> <svg class="Button__Icon"> <use xlink:href="#delete-icon"></use> </svg> </button> </div> </div> <div if="{!this.edit}" class="modal-content"> <div class="modal-header"> <h2 class="modal-title">Attach image or file…</h2> <button class="modal-close" onclick="{dismiss}"> <i class="modal-close_icon material-icons">close</i> </button> </div> <label for="file-input"> <div class="dropzone-container"> <div ref="dropzone" class="drop-zone {isSubscriber() ? \'subscriber\' : \'\'}" ondragover="{handleDragOver}" ondrop="{handleDrop}" ondragenter="{handleDragEnter}" ondragleave="{handleDragLeave}"></div> </div> <form> <input type="file" id="file-input" style="display:none"> </form> </label> </div> <div if="{!isSubscriber() && !this.edit}" class="modal-footer"> <div class="modal-footer_content"> <span>Attach files up to {SUBSCRIBER_FILE_MAX_SIZE / 1000000}MB by</span> <a href="/pricing">upgrading to Plectica Pro</a> </div> </div> </div> </div>',
  '',
  'ref="root"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants.js');

var _files = require('lib/files.js');

var _nodeImage = require('lib/node-image.js');

var _util = require('lib/util');

var _nodeFile = require('lib/node-file.js');

var _nodeFile2 = _interopRequireDefault(_nodeFile);

var _upsellUi = require('lib/upsell-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

this.SUBSCRIBER_FILE_MAX_SIZE = _constants.SUBSCRIBER_FILE_MAX_SIZE;

var _window = window,
    user = _window.user;

var self = this;
this.canvas = this.opts.canvas;
this.operation = this.canvas.operation;
this.canvas.imageModal = this;
this.open = false;

this.triggerEdit = function (nodeUUID) {
  _this.show(nodeUUID, { edit: true });
};

this.show = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(nodeUUID) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var node, fileType;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            node = store.getNode(nodeUUID);

            _this.edit = opts.edit;
            _this.nodeUUID = nodeUUID;
            _this.open = true;
            _this.edited = false;
            _this.cleanupBeforeShow();

            if (!_this.edit) {
              _context.next = 16;
              break;
            }

            fileType = store.getNode(nodeUUID).attachedFile.file_type;

            if (!_constants.ALLOWED_IMAGE_FILE_TYPES.includes(fileType)) {
              _context.next = 14;
              break;
            }

            _context.next = 11;
            return _nodeImage.NodeImage.create({ nodeUUID: nodeUUID, isNewImage: false, canvas: _this.canvas });

          case 11:
            _this.nodeImage = _context.sent;
            _context.next = 15;
            break;

          case 14:
            _this.nodeFile = _nodeFile2.default.create({ nodeUUID: nodeUUID, isNew: false, canvas: _this.canvas });

          case 15:

            if (_this.refs.previewImage) {
              _this.refs.previewImage.src = _this.previewSrc();
            }

          case 16:

            _this.canvas.searchModal.dismiss();
            $('modal-image .modal-background').fadeIn();
            $('modal-image .modal').fadeIn();
            _this.update();

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

this.dismiss = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  var node = _this.canvas.store.getNode(_this.nodeUUID);
  if (node.cardless && !node.attachedFile) {
    _this.canvas.deleteNode(node.id, false);
  }

  _this.open = false;
  _this.nodeImage = null;
  _this.nodeFile = null;
  _this.removeKeyboardListener();
  _this.canvas.hidePopups();
  if (_this.refs.dropzone) {
    _this.refs.dropzone.classList.remove('dragged-over');
  }
  if (_this.refs.spinner) {
    _this.refs.spinner.classList.remove('spinning');
  }
  $('.modal-background').fadeOut();
  $('.modal').fadeOut();
};

this.isOpen = function () {
  return $('#image-modal').is(':visible');
};

this.cleanupBeforeShow = function () {
  if (_this.refs.previewImage) {
    _this.refs.previewImage.src = '';
  }
  _this.addFileInputListener();
  if (_this.refs.dropzone) {
    _this.refs.dropzone.classList.remove('dragged-over');
  }
  _this.canvas.hidePopups();
  if (_this.refs.spinner) {
    _this.refs.spinner.classList.remove('spinning');
  }
  _this.enableButtons();
};

this.disableButtons = function () {
  if (_this.refs.previewContainer) {
    _this.refs.previewContainer.classList.add('rotating');
  }
  if (_this.refs.rotateButton) {
    _this.refs.rotateButton.disabled = true;
  }
  if (_this.refs.saveButton) {
    _this.refs.saveButton.disabled = true;
  }
  if (_this.refs.removeButton) {
    _this.refs.removeButton.disabled = true;
  }
};

this.enableButtons = function () {
  if (_this.refs.previewContainer) {
    _this.refs.previewContainer.classList.remove('rotating');
  }
  if (_this.refs.rotateButton) {
    _this.refs.rotateButton.disabled = false;
  }
  if (_this.refs.saveButton) {
    _this.refs.saveButton.disabled = false;
  }
  if (_this.refs.removeButton) {
    _this.refs.removeButton.disabled = false;
  }
};

this.addKeyboardListener = function () {
  if (_this.isOpen()) {
    document.addEventListener('keyup', _this.handleKeyup);
  } else {
    _this.removeKeyboardListener();
  }
};

this.removeKeyboardListener = function () {
  document.removeEventListener('keyup', _this.handleKeyup);
};

this.handleKeyup = function (e) {
  var ENTER = _constants.KEY_CODES.ENTER,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if (e.keyCode == ESCAPE) {
    _this.dismiss();
  } else if (e.keyCode == ENTER) {
    //TODO test this
    _this.uploadFile();
  }
};

this.on('mount', function () {
  _this.addKeyboardListener();
  _this.addFileInputListener();
});

this.on('updated', function () {
  _this.addKeyboardListener();
  _this.addFileInputListener();
});

this.rotateImage = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
    var rotatedDataURL;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _this.disableButtons();
            _context2.next = 3;
            return _this.nodeImage.rotateImage();

          case 3:
            rotatedDataURL = _context2.sent;

            _this.enableButtons();
            _this.edited = true;
            _this.update();
            _this.refs.previewImage.src = rotatedDataURL;

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x3) {
    return _ref2.apply(this, arguments);
  };
}();

this.addFileInputListener = function () {
  _this.clearError();

  var fileInput = document.getElementById('file-input');
  var handleFileInputChange = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var file, maxFileSize, dimensions;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(fileInput.files && fileInput.files[0])) {
                _context3.next = 27;
                break;
              }

              file = fileInput.files[0];
              maxFileSize = user && user.active_subscription_plan && user.active_subscription_plan ? _constants.SUBSCRIBER_FILE_MAX_SIZE : _constants.FILE_MAX_SIZE;

              if (!(file.size > maxFileSize)) {
                _context3.next = 6;
                break;
              }

              _this.handleError('file-size-error');
              return _context3.abrupt('return');

            case 6:

              fileInput.value = null;
              //TODO something better here about detecting images vs other files.

              if (!_constants.ALLOWED_IMAGE_FILE_TYPES.includes(file.type)) {
                _context3.next = 13;
                break;
              }

              _context3.next = 10;
              return _nodeImage.NodeImage.create({ nodeUUID: _this.nodeUUID, isNewImage: true, file: file, canvas: _this.canvas });

            case 10:
              _this.nodeImage = _context3.sent;
              _context3.next = 24;
              break;

            case 13:
              _this.nodeFile = _nodeFile2.default.create({ nodeUUID: _this.nodeUUID, isNew: true, file: file, canvas: _this.canvas });
              if (_this.refs.spinner) {
                _this.refs.spinner.classList.add('spinning');
              }

              if (!(0, _util.canPlayVideo)(file.type)) {
                _context3.next = 20;
                break;
              }

              _context3.next = 18;
              return (0, _util.getVideoDimensions)(file);

            case 18:
              dimensions = _context3.sent;

              _this.nodeFile.file_attributes = dimensions;

            case 20:
              _this.edited = true;
              _this.edit = true;
              _this.update();
              _this.uploadFile();

            case 24:
              _this.edit = true;
              _this.edited = true;
              _this.update();

            case 27:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function handleFileInputChange() {
      return _ref3.apply(this, arguments);
    };
  }();

  if (fileInput) {
    fileInput.removeEventListener('change', handleFileInputChange);
    fileInput.addEventListener('change', handleFileInputChange);
  }
};

this.handleError = function (error) {
  _this.clearError();
  _this.error = error;
  $('#file-input').val(null);
  if (_this.refs.dropzone) {
    _this.refs.dropzone.classList.add(error);
    _this.clearErrorTimeout = setTimeout(_this.clearError, 2000);
  }
};

this.clearError = function () {
  clearTimeout(_this.clearErrorTimeout);
  _this.clearErrorTimeout = null;

  if (_this.refs.dropzone) {
    _this.refs.dropzone.classList.remove(_this.error);
    _this.error = null;
  }
};

this.handleDragOver = function (e) {
  e.preventDefault(); // necessary to make drop handler fire!
};

this.handleDragEnter = function (e) {
  _this.refs.dropzone.classList.add('dragged-over');
};

this.handleDragLeave = function (e) {
  _this.refs.dropzone.classList.remove('dragged-over');
};

this.handleDrop = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
    var dt, file, i, maxFileSize, dimensions;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            e.preventDefault();
            // If dropped items aren't files, reject them
            self.refs.dropzone.classList.remove('file-type-error');
            self.refs.dropzone.classList.remove('file-size-error');
            self.refs.dropzone.classList.remove('file-upload-error');
            dt = e.dataTransfer;
            file = void 0;

            for (i = 0; i < dt.items.length; i++) {
              if (dt.items[i].kind == "file") {
                file = dt.items[i].getAsFile();
              }
            }

            _this.refs.dropzone.classList.remove('dragged-over');
            maxFileSize = user && user.active_subscription_plan && user.active_subscription_plan === 'basic-monthly' ? _constants.SUBSCRIBER_FILE_MAX_SIZE : _constants.FILE_MAX_SIZE;

            if (!(file.size > maxFileSize)) {
              _context4.next = 12;
              break;
            }

            _this.handleError('file-size-error');
            return _context4.abrupt('return');

          case 12:
            if (!_constants.ALLOWED_IMAGE_FILE_TYPES.includes(file.type)) {
              _context4.next = 18;
              break;
            }

            _context4.next = 15;
            return _nodeImage.NodeImage.create({ nodeUUID: _this.nodeUUID, isNewImage: true, file: file, canvas: _this.canvas });

          case 15:
            _this.nodeImage = _context4.sent;
            _context4.next = 31;
            break;

          case 18:
            if (_this.refs.spinner) {
              _this.refs.spinner.classList.add('spinning');
            }

            _context4.next = 21;
            return _nodeFile2.default.create({ nodeUUID: _this.nodeUUID, isNew: true, file: file, canvas: _this.canvas });

          case 21:
            _this.nodeFile = _context4.sent;

            if (!(0, _util.canPlayVideo)(file.type)) {
              _context4.next = 27;
              break;
            }

            _context4.next = 25;
            return (0, _util.getVideoDimensions)(file);

          case 25:
            dimensions = _context4.sent;

            _this.nodeFile.file_attributes = dimensions;

          case 27:

            _this.edited = true;
            _this.edit = true;
            _this.update();
            _this.uploadFile();

          case 31:
            _this.edited = true;
            _this.edit = true;
            _this.update();

          case 34:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function (_x4) {
    return _ref4.apply(this, arguments);
  };
}();

this.removeFile = function () {
  if (_this.edited) {
    _this.updateNode({ removeFile: true });
  } else {
    _this.operation.deleteNodeFile({
      nodeUUID: _this.nodeUUID,
      fileUUID: _this.nodeImage ? _this.nodeImage.getUUID() : _this.nodeFile.uuid,
      fileUrl: _this.nodeImage ? _this.nodeImage.getFileUrl() : _this.nodeFile.file_url,
      fileType: _this.nodeImage ? _this.nodeImage.getFileType() : _this.nodeFile.file_type,
      fileSize: _this.nodeImage ? _this.nodeImage.getFileSize() : _this.nodeFile.file_size,
      fileAttributes: _this.nodeImage ? _this.nodeImage.getFileAttributes(_this.canvas) : _this.nodeFile.file_attributes,
      displayProperties: _this.nodeImage ? _this.nodeImage.getDisplayProperties(_this.canvas) : _this.nodeFile.display_properties,
      previewFileUrl: _this.nodeImage ? _this.nodeImage.getPreviewFileUrl() : null,
      onSuccess: _this.updateNode.bind(_this, { removeFile: true }),
      onFailure: function onFailure(err) {
        return console.log(err);
      }
    });
  }
  _this.nodeFile = null;
  _this.nodeImage = null;
};

this.updateNode = function (_ref5) {
  var removeFile = _ref5.removeFile,
      fileUrl = _ref5.fileUrl,
      fileUUID = _ref5.fileUUID,
      fileType = _ref5.fileType,
      fileAttributes = _ref5.fileAttributes,
      displayProperties = _ref5.displayProperties,
      previewFileUrl = _ref5.previewFileUrl,
      name = _ref5.name;

  var timeToDismiss = void 0;
  if (removeFile) {
    store.getNode(_this.nodeUUID).updateNode({
      attachedFile: null
    });
    _this.edit = false;
  } else {
    if (_constants.ALLOWED_IMAGE_FILE_TYPES.includes(fileType) && !displayProperties.size) {
      displayProperties.size = _this.canvas.defaultImageSize;
    }
    var cardless = _constants.ALLOWED_IMAGE_FILE_TYPES.includes(fileType) || (0, _util.canPlayVideo)(fileType);

    store.getNode(_this.nodeUUID).updateNode({
      cardless: cardless,
      attachedFile: {
        file_type: fileType,
        file_url: fileUrl,
        uuid: fileUUID,
        file_attributes: fileAttributes,
        preview_url: previewFileUrl,
        display_properties: displayProperties,
        name: name
      }
    });
    timeToDismiss = true;
  }
  _this.canvas.nodeTags[_this.nodeUUID].updateLayers();
  _this.canvas.nodeTags[_this.nodeUUID].updateTopLevelNeighborsLite();
  _this.canvas.hidePopups();
  _this.update();
  if (timeToDismiss) {
    _this.dismiss();
  }
};

this.uploadFile = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e) {
    var file, previewFile, stopSpinner, credentials, fileUUID, fileUrl, formData, recordFileUpload, previewFormData;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (e && e.preventDefault) {
              e.preventDefault();
            }
            _this.disableButtons();

            if (_this.edited) {
              _context5.next = 5;
              break;
            }

            _this.dismiss();
            return _context5.abrupt('return');

          case 5:
            file = _this.nodeImage ? _this.nodeImage.getFile() : _this.nodeFile.getFile();
            previewFile = _this.nodeImage ? _this.nodeImage.getPreviewFile() : null;

            if (_this.refs.spinner) {
              _this.refs.spinner.classList.add('spinning');
            }

            stopSpinner = function stopSpinner() {
              _this.refs.spinner.classList.remove('spinning');
            };

            _context5.next = 11;
            return $.ajax({
              type: 'GET',
              url: '/api/maps/upload/credentials',
              data: {
                mapId: _this.canvas.store.getMapId(),
                filename: _this.getFileName()
              }
            });

          case 11:
            credentials = _context5.sent;
            fileUUID = credentials.fileUUID;
            fileUrl = credentials.fileUrl;
            formData = new FormData();

            formData.append('file', file);

            recordFileUpload = function recordFileUpload(result) {
              var previewFileUrl = void 0;
              if (previewFile) {
                previewFileUrl = credentials.previewFileUrl;
              }
              stopSpinner();
              _this.enableButtons();
              var operationFn = _this.edit && _this.nodeImage ? _this.operation.rotateNodeFile.bind(_this.operation) : _this.operation.addFileToNode.bind(_this.operation);

              var node = store.getNode(_this.nodeUUID);
              var prevFile = void 0;
              // todo: grab this prev file data before rotate happens
              if (node.attachedFile) {
                var _file = node.attachedFile;
                prevFile = {
                  nodeUUID: _this.nodeUUID,
                  fileUUID: _file.uuid,
                  fileType: _file.file_type,
                  fileSize: _file.file_size,
                  fileAttributes: Object.assign({}, _file.file_attributes),
                  displayProperties: Object.assign({}, _file.display_properties),
                  fileUrl: _file.file_url,
                  previewFileUrl: _file.preview_url,
                  name: _file.name
                };
              }

              operationFn({
                nodeUUID: _this.nodeUUID,
                fileUUID: fileUUID,
                fileUrl: '' + fileUrl,
                previewFileUrl: previewFileUrl ? '' + previewFileUrl : null,
                fileType: _this.nodeImage ? _this.nodeImage.getFileType() : _this.nodeFile.file_type,
                fileSize: _this.nodeImage ? _this.nodeImage.getFileSize() : _this.nodeFile.file_size,
                fileAttributes: _this.nodeImage ? _this.nodeImage.getFileAttributes() : _this.nodeFile.file_attributes,
                displayProperties: _this.nodeImage ? _this.nodeImage.getDisplayProperties(_this.canvas) : _this.nodeFile.display_properties,
                name: _this.nodeFile ? _this.nodeFile.name : '',
                prevFile: prevFile,
                onSuccess: _this.updateNode.bind(_this, {
                  fileUrl: '' + fileUrl,
                  previewFileUrl: previewFileUrl ? '' + previewFileUrl : null,
                  fileUUID: fileUUID,
                  fileType: _this.nodeImage ? _this.nodeImage.getFileType() : _this.nodeFile.file_type,
                  fileSize: _this.nodeImage ? _this.nodeImage.getFileSize() : _this.nodeFile.file_size,
                  fileAttributes: _this.nodeImage ? _this.nodeImage.getFileAttributes() : _this.nodeFile.file_attributes,
                  displayProperties: _this.nodeImage ? _this.nodeImage.getDisplayProperties(_this.canvas) : _this.nodeFile.display_properties,
                  name: _this.nodeFile ? _this.nodeFile.name : ''
                }),
                onFailure: function onFailure(err) {
                  return console.log(err);
                }
              });
            };

            if (previewFile) {
              previewFormData = new FormData();

              previewFormData.append('file', previewFile);

              (0, _files.sendFileToAmazon)({
                url: credentials.previewEndpointUrl,
                file: previewFile,
                onSuccess: _files.sendFileToAmazon.bind(_this, {
                  url: credentials.endpoint_url,
                  file: file,
                  onSuccess: recordFileUpload
                }),
                onFailure: function onFailure(err) {
                  stopSpinner();
                  _this.handleError('file-upload-error');
                }
              });
            } else {
              (0, _files.sendFileToAmazon)({
                url: credentials.endpoint_url,
                file: file,
                onSuccess: recordFileUpload,
                onFailure: function onFailure(err) {
                  stopSpinner();
                  _this.handleError('file-upload-error');
                }
              });
            }

          case 18:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x5) {
    return _ref6.apply(this, arguments);
  };
}();

this.previewSrc = function () {
  if (_this.nodeImage) {
    return _this.nodeImage.getPreviewFileUrl() || _this.nodeImage.getFileUrl();
  } else if (_this.nodeFile) {
    return _this.nodeFile.getPreviewFileUrl();
  }
};

this.showRotateButton = function () {
  if (_this.nodeImage) {
    return _this.nodeImage.getFileType !== 'image/gif';
  } else {
    //we're not an image
    return false;
  }
};

this.isImage = function () {
  return Boolean(_this.nodeImage);
};

this.getFileName = function () {
  return _this.nodeImage ? _this.nodeImage.getFileName() : _this.nodeFile ? _this.nodeFile.name : '';
};

this.getIconName = function () {
  return (0, _util.getIconNameFromExtension)(_this.getFileExtension());
};

this.getFileExtension = function () {
  var name = _this.getFileName();
  if (name && name.includes('.')) {
    return '.' + name.split('.')[name.split('.').length - 1];
  } else {
    return '';
  }
};

this.isSubscriber = _upsellUi.usui.isSubscriber.bind(_upsellUi.usui);

this.titleText = function () {
  if (_this.nodeImage) {
    return "Edit Image ...";
  } else {
    return "Edit File ...";
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-image')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-image.html
// module id = 629
// module chunks = 0